import { Button, GridView, MasterDetailForm, Widget } from '@digital/ui';
import React, { useState, useEffect } from 'react';
import { Collapse, Icon } from 'antd';
import { FechamentoRegistroEsin204, getFechamentExecutadoByFechamentoId } from '@app/api/fechamento';
import FechamentoModuloExecutadoTabela from './fechamentoModuloExecutadoTabela';
const { Panel } = Collapse;


interface FechamentoModuloExecutadoProps {
    fechamentoId: string;
}


const FechamentoModuloExecutado = (props: FechamentoModuloExecutadoProps) => {

    const { fechamentoId } = props;

    const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<FechamentoRegistroEsin204[]>();

    useEffect(() => {
        if (fechamentoId) {
            getFechamentExecutadoByFechamentoId(fechamentoId).then((data) => {
                if (data && data.length > 0) {
                    setCicloOrcamentarioRelatorioTotal(data);
                }
            });
        }

    }, [fechamentoId]);

    const carregarTadadosDaTabela = (ano: number) => {
        if (cicloOrcamentarioRelatorioTotal) {
            const novoValor = cicloOrcamentarioRelatorioTotal.map((result) => {
                if (result.ano === ano) {
                    result.carregarMesAno = true;
                }
                return result;
            });
            setCicloOrcamentarioRelatorioTotal(novoValor);
        }
    }

    const bthExporta = () => {


        return [];
    }


    return (

        <GridView noform>
            {cicloOrcamentarioRelatorioTotal && cicloOrcamentarioRelatorioTotal.length > 0 ? (
                cicloOrcamentarioRelatorioTotal.map((fechamentoRegistroEsin204) => {
                    return (<>
                        {
                            <Collapse
                                key={fechamentoRegistroEsin204.ano}
                                onChange={(key) => {
                                    carregarTadadosDaTabela(fechamentoRegistroEsin204.ano)
                                }}
                                bordered={false}
                                expandIcon={() => <Icon type="arrows-right_4" />}
                            >
                                <Panel key="2" header={`${fechamentoRegistroEsin204.ano}`} style={{ border: 0 }}>
                                    <MasterDetailForm>
                                        <Widget actions={bthExporta()}>
                                            {
                                                fechamentoRegistroEsin204.carregarMesAno === true ?
                                                    (
                                                        <FechamentoModuloExecutadoTabela
                                                            ano={fechamentoRegistroEsin204.ano}
                                                            carregarTabela={fechamentoRegistroEsin204.carregarMesAno}
                                                            fechamentoId={fechamentoId}
                                                            meses={fechamentoRegistroEsin204.meses}
                                                        />
                                                    ) :
                                                    (
                                                        <>
                                                        </>
                                                    )
                                            }
                                        </Widget>
                                    </MasterDetailForm>
                                </Panel>
                            </Collapse>
                        }
                    </>)
                })

            ) : (<> Não entrou </>)}
        </GridView >

    );

}

export default FechamentoModuloExecutado;

